import cls from "./Modal.module.scss";
import {classNames} from "shared/lib/classNames/classNames";
import React, {ReactNode, useCallback, useEffect} from "react";

interface ModalProps {
    className?: string;
    children?: ReactNode;
    isOpen?: boolean;
    onClose?: () => void;
}

const Modal = (props: ModalProps) => {
    const { className, children, isOpen=true, onClose } = props;

    const handleClose = useCallback(() => {
        if (onClose) {
            onClose();
        }
    }, [onClose])

    const onKeyDown = useCallback((e: KeyboardEvent) => {
        if (e.key === "Escape") {
            onClose?.();
        }
    }, [onClose])

    useEffect(() => {
        if (isOpen) {
            window.addEventListener("keydown", onKeyDown);
        }

        return () => {
            window.removeEventListener("keydown", onKeyDown);
        }
    }, [isOpen])

    const onContentClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
    }

    const mods: Record<string, boolean> = {
        [cls.opened]: isOpen,
    }

    return (
        <div className={classNames(cls.Modal, mods, [className])}>
            <div className={cls.overlay} onClick={handleClose}>
                <div className={cls.content} onClick={onContentClick}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Modal;
